<template>
  <v-select v-model="selectedYear" :items="years" density="compact"> </v-select>
</template>

<script>
export default {
  data: () => ({
    selectedYear: null,
    years: Array.from({ length: 216 }, (_, i) => new Date().getFullYear() - i), // Generate years
  }),
};
</script>
